import React, { useEffect, useState } from 'react';
import Nav from '../components/Navigation/Nav';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Frontend/Footer/Footer';
import { Link } from 'react-feather';
import { BASE_URL, JS_CSS_IMG_VERSION } from '../config/apiConfig';
//import './Nav.css';

const ClientLayout = () => {

  const location = useLocation();

  const [show_footer, showFooter] = useState(true)

  useEffect(() => {
    // Check URL path and set the expanded state
    if (location.pathname.indexOf('ai_assistant') !== -1) {
      showFooter(false);
    }else{
      showFooter(true);
    }

  }, [location.pathname]);

  return (
    <div className="main-layout1"> 
       <nav className={`navbar navbar-expand-lg navbar-default`}>
            <div className="container">
              <a className="navbar-brand" href='/'>
                <img src={`${BASE_URL}/img/mnm_logo_inner.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="140" className="" />
              </a>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
        </nav>
      <div className="row">
        <div className="content col-md-12">
          <div className="main_content">
            <Outlet />
          </div>
          {show_footer && <Footer /> }
        </div>
      </div>
    </div>
  );
};

export default ClientLayout;
